<template>
  <div class="aboutNews">
    <div class="newsList">
      <div class="list" v-for="item in lists" :key="item.id" @click="goDetail(item.link)">
        <div class="imgArea">
          <img :src="item.url" alt="">
        </div>
        <div class="textArea">
          <div class="compTitleTwo">{{ item.title }}</div>
          <div class="compText">{{ item.text }}</div>
          <div class="time">
            <div>{{ item.time }}</div>
            <div><img src="../assets/images/rightG.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutNews',
  components: {},
  data() {
    return {
      lists: [
        {
          id: '1',
          title: '【荣誉殿堂】风采展示-壹心保代篇',
          text: '公司标保MDRT更是行业中的尖端，入围标准远超行业MDRT。你们站在了荣誉的巅峰，是公司的骄傲，也是行业的翘楚。',
          url: require('../assets/images/news-1.jpeg'),
          link: 'https://mp.weixin.qq.com/s/76G4pMjIHtNPx-g0xyOJmw',
          time: '2022.2.21'
        },
        {
          id: '2',
          title: '壹心科技全体员工给您拜年啦！',
          text: '祝您在新的一年里虎啸山林，龙腾虎跃。',
          url: require('../assets/images/news-2.png'),
          link: 'https://mp.weixin.qq.com/s/wCo7W-W7g6_7Cy5dFjtRpw',
          time: '2022.1.30'
        },
        // {
        //   id: '3',
        //   title: '【破亿】热烈祝贺壹心个险业务1月单月保费规模破亿',
        //   text: '壹心有你，大事可期',
        //   url: require('../assets/images/news-3.jpeg'),
        //   link: 'https://mp.weixin.qq.com/s/0iz49BBzKgsHAz1J3oNx4w',
        //   time: '2022.1.30'
        // },
        {
          id: '4',
          title: '【年度盘点】2021-2022壹心年度盘点',
          text: '凝心聚力踏新程，上下同欲开新篇',
          url: require('../assets/images/news-4.jpeg'),
          link: 'https://mp.weixin.qq.com/s/wc9YCpJG-SL_gaDdCky2_A',
          time: '2022.1.30'
        },
        {
          id: '5',
          title: '喜迎建党百年 ｜壹心组织收看庆祝中国共产党成立一百周年大会',
          text: '百年征程波澜壮阔，百年初心历久弥坚',
          url: require('../assets/images/news-5.jpeg'),
          link: 'https://mp.weixin.qq.com/s/Ri3v977JVg1N14agzMk9hg',
          time: '2021.7.1'
        },
        {
          id: '6',
          title: '会凌云之巅，铸梦想荣光|壹心2021年度全国至尊盛典峰会圆满落幕',
          text: '汇聚壹心家人力量，点亮保险未来！为期三天的壹心全国至尊盛典峰会圆满落幕',
          url: require('../assets/images/news-6.jpeg'),
          link: 'https://mp.weixin.qq.com/s/3dTAVGj5-WjACd2flV9ZvQ',
          time: '2021.6.29'
        },
        {
          id: '7',
          title: '壹心公益丨“春藤成长计划”交大附中学生节捐赠仪式',
          text: '中华社会救助基金会公益项目“春藤成长计划”交大附中爱心校园行于2021年5月14日随该校一年一度的学生节正式启动。',
          url: require('../assets/images/news-7.jpeg'),
          link: 'https://mp.weixin.qq.com/s/TcZ0DMVWE-kNsg2SAV5scA',
          time: '2021.5.19'
        },
        {
          id: '8',
          title: '倾情推出 | 壹心科技鲸云保Club宣传片来啦！',
          text: '今天，壹心科技鲸云保Club宣传片震撼发布！ ',
          url: require('../assets/images/news-8.jpg'),
          link: 'https://mp.weixin.qq.com/s/UnGVbzJt31sL33G1MmD_xA',
          time: '2021.4.23'
        },
        {
          id: '9',
          title: '您有一封新年来信，请查收！',
          text: '致敬每一位奋斗的壹心人',
          url: require('../assets/images/news-9.jpeg'),
          link: 'https://mp.weixin.qq.com/s/bGj1XjjtdUNaA4wvuCp_KQ',
          time: '2021.1.1'
        },
        {
          id: '10',
          title: '壹心科技平台赋能｜联合主办2020年浙江省保险中介行业交流会',
          text: '2020年11月初，由壹心科技、智保云、微易科技及上海保交所联合主办了新形势下保险中介信息化之路暨2020年浙江省保险中介行业交流会在浙江杭州成功召开。',
          url: require('../assets/images/news-10.jpeg'),
          link: 'https://mp.weixin.qq.com/s/LF2GRwSzKAQUb33z_xbeyw',
          time: '2020.11.17'
        },

      ]
    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {
    goDetail(val) {
      window.open(val)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.aboutNews {
  width: 1024px;
  margin: 0 auto;

  &>div {
    margin-top: 30px;
  }

  .newsList {
    .list {
      display: flex;
      margin-bottom: 40px;
      width: 1024px;
      height: 172px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);

      .imgArea {
        width: 304px;
        height: 172px;
        background-color: #DFDFDF;

        img {
          width: 304px;
          height: 172px;
        }
      }

      .textArea {
        padding: 24px;
        background-color: #FBFBFB;
        flex: 1;
      }

      .compText {
        margin-top: 12px;
      }

      .time {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        color: #666666;
        font-size: 16px;

        img {
          width: 30px;
        }
      }
    }
  }

}</style>